module.exports = __webpack_public_path__ + "img/vision.e5139167.svg";